import * as React from "react";
import {
    Grid,
    InputLabel,
    TextField,
} from "@material-ui/core";
import CommonFieldsSection from "./CommonFieldsSection";

interface IProps {
    data?: any;
    isAmazonCustomer?: any;
}
interface IState {
    cardholderId: any,
    personCode: any,
    patientRelationshipCode: any,
    binNumber: any,
    pcn: any,
    groupNumber: any,
    benefitStartDate: any,
    benefitEndDate: any,
    externalClientReference: any,
    enrollmentPartner: any
}
class BSCASpecificSection extends React.Component<IProps, IState> {

    private commonFieldsSection: any;
    constructor(props: IProps) {
        super(props);

        this.state = {
            benefitEndDate: '2029-05-22T00:00+00:00',
            benefitStartDate: '2024-05-22T00:00+00:00',
            binNumber: '026696',
            cardholderId: '',
            enrollmentPartner: 'BSCA',
            externalClientReference: '900807428X0001000',
            groupNumber: '00759200067002',
            patientRelationshipCode: '1',
            pcn: '',
            personCode: '01',
        };

        this.handleBenefitEndDate = this.handleBenefitEndDate.bind(this);
        this.handleBenefitStartDate = this.handleBenefitStartDate.bind(this);
        this.handleBinNumber = this.handleBinNumber.bind(this);
        this.handleCardholderId = this.handleCardholderId.bind(this);
        this.handleGroupNumber = this.handleGroupNumber.bind(this);
        this.handlePatientRelationshipCode = this.handlePatientRelationshipCode.bind(this);
        this.handlePcn = this.handlePcn.bind(this);
        this.handlePersonCode = this.handlePersonCode.bind(this);
        this.handleExternalClientReference = this.handleExternalClientReference.bind(this);
        this.handleEnrollmentPartner = this.handleEnrollmentPartner.bind(this);
    }

    public render() {
        return (

            <Grid item xs={12}>

                <CommonFieldsSection ref={(ref) => this.commonFieldsSection = ref}/>
            <Grid
                container
                direction="column"
                justify="center"
                alignItems="center"
                spacing={3}
            >
                <Grid item xs>
                    <InputLabel style={{
                        color: "red",
                        fontSize: 18,
                        fontWeight: "bold",
                    }}>BSCA Specific fields</InputLabel>
                </Grid>

                <Grid item xs>
                    <TextField
                        style={{width: 225}}
                        label="External client reference (Required)"
                        variant="outlined"
                        value={this.state.externalClientReference}
                        onChange={this.handleExternalClientReference}
                    />
                </Grid>

                <Grid item xs>
                    <TextField
                        style={{width: 225}}
                        label="Enrollment Partner (Required)"
                        variant="outlined"
                        value={this.state.enrollmentPartner}
                        onChange={this.handleEnrollmentPartner}
                    />
                </Grid>

                <Grid item xs>
                    <TextField
                        style={{width: 225}}
                        label="Cardholder Id (Required)"
                        variant="outlined"
                        value={this.state.cardholderId}
                        onChange={this.handleCardholderId}
                    />
                </Grid>

                <Grid item xs>
                    <TextField
                        style={{width: 225}}
                        label="Person code (Required)"
                        variant="outlined"
                        value={this.state.personCode}
                        onChange={this.handlePersonCode}
                    />
                </Grid>

                <Grid item xs>
                    <TextField
                        style={{width: 225}}
                        label="Patient Relationship code (Required)"
                        variant="outlined"
                        value={this.state.patientRelationshipCode}
                        onChange={this.handlePatientRelationshipCode}
                    />
                </Grid>

                <Grid item xs>
                    <TextField
                        style={{width: 225}}
                        label="Bin number (Required)"
                        variant="outlined"
                        value={this.state.binNumber}
                        onChange={this.handleBinNumber}
                    />
                </Grid>

                <Grid item xs>
                    <TextField
                        style={{width: 225}}
                        label="PCN (Required)"
                        variant="outlined"
                        value={this.state.pcn}
                        onChange={this.handlePcn}
                    />
                </Grid>

                <Grid item xs>
                    <TextField
                        style={{width: 225}}
                        label="Group number (Optional)"
                        variant="outlined"
                        value={this.state.groupNumber}
                        onChange={this.handleGroupNumber}
                    />
                </Grid>

                <Grid item xs>
                    <TextField
                        style={{width: 225}}
                        label="Benefit start date (Required)"
                        variant="outlined"
                        value={this.state.benefitStartDate}
                        onChange={this.handleBenefitStartDate}
                    />
                </Grid>

                <Grid item xs>
                    <TextField
                        style={{width: 225}}
                        label="Benefit End date (Required)"
                        variant="outlined"
                        value={this.state.benefitEndDate}
                        onChange={this.handleBenefitEndDate}
                    />
                </Grid>

            </Grid>
            </Grid>

        );
    }

    public handleBenefitEndDate(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({benefitEndDate: event.target.value})
    }

    public handleBenefitStartDate(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({benefitStartDate: event.target.value})
    }

    public handleBinNumber(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({binNumber: event.target.value})
    }

    public handleCardholderId(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({cardholderId: event.target.value})
    }

    public handleGroupNumber(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({groupNumber: event.target.value})
    }

    public handlePatientRelationshipCode(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({patientRelationshipCode: event.target.value})
    }

    public handlePcn(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({pcn: event.target.value})
    }

    public handlePersonCode(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({personCode: event.target.value})
    }

    public handleExternalClientReference(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({externalClientReference: event.target.value})
    }

    public handleEnrollmentPartner(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({enrollmentPartner: event.target.value})
    }

    public getState() {
        return this.state;
    }

    public getCommonFieldsSection() {
        return this.commonFieldsSection;
    }

    public getHealthInsurancesList(){
        return [{
            benefitEndDate: this.state.benefitEndDate,
            benefitStartDate: this.state.benefitStartDate,
            binNumber: this.state.binNumber,
            cardholderId: this.state.cardholderId,
            groupNumber: this.state.groupNumber,
            patientRelationshipCode: this.state.patientRelationshipCode,
            pcn: this.state.pcn,
            personCode: this.state.personCode
        }]
    }

}

export default BSCASpecificSection
